// extracted by mini-css-extract-plugin
module.exports = {"readMore":"ReadMore_readMore__3XSvj","hider":"ReadMore_hider__mHvZQ","readMoreButton":"ReadMore_readMoreButton__1UPXz"};